import { gql } from '@apollo/client';

export const GET_ONE_DEPARTMENT = gql`
	query getOneDepartment($_id: ID!) {
		department: getOneDepartment(_id: $_id) {
			_id
			name
		}
	}
`;

export const PAGINATE_DEPARTMENTS = gql`
	query paginateDepartments(
		$skip: Int
		$limit: Int
		$search: String
		$order: Int
		$orderBy: String
	) {
		departments: paginateDepartments(
			skip: $skip
			limit: $limit
			search: $search
			order: $order
			orderBy: $orderBy
		) {
			count
			items {
				_id
				name
			}
		}
	}
`;

export const GET_DEPARTMENTS = gql`
	query getDepartments {
		departments: getDepartments {
			_id
			name
		}
	}
`;
